import { RootState } from "@src/reducers/store";
import React, { ReactNode, useState, useEffect } from "react";
import { useSelector } from "react-redux";

interface RenderIfUserHasPermissionProps {
  children: ReactNode;
  permission: string;
  invert?: boolean;
}

export const RenderIfUserHasPermission = ({
  children,
  permission,
  invert = false,
}: RenderIfUserHasPermissionProps) => {
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    if (authContext) {
      setHasPermission(authContext.permissions.includes(permission));
    }
  }, [authContext, permission]);

  if (invert) {
    return !hasPermission ? <>{children}</> : null;
  } else {
    return hasPermission ? <>{children}</> : null;
  }
};
